import { fromJS as ImmutableFromJs } from 'immutable';
import FrontEndApi from '../Globals/Scripts/FrontEndApi';

const loadMenu = async () => {
    const json = await FrontEndApi.getMenuStructureByUser();
    return ImmutableFromJs(json);
};

export default { loadMenu };
